import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import { FiFilter } from 'react-icons/fi';


const ReportFilters = ({ campaignType, setCampaignType }) => {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
      <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center">
        <div className="flex items-center gap-2">
          <SafeIcon icon={FiFilter} className="text-gray-400" />
          <span className="text-sm font-medium text-gray-700">Filters:</span>
        </div>

        <div className="flex flex-wrap gap-4">
          <div>
            <label className="block text-xs text-gray-500 mb-1">Campaign Type</label>
            <select
              value={campaignType}
              onChange={(e) => setCampaignType(e.target.value)}
              className="border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              <option value="all">All Types</option>
              <option value="email">Email Campaigns</option>
              <option value="call">Call Campaigns</option>
            </select>
          </div>

          <div>
            <label className="block text-xs text-gray-500 mb-1">Status</label>
            <select className="border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent">
              <option value="all">All Status</option>
              <option value="active">Active</option>
              <option value="completed">Completed</option>
              <option value="paused">Paused</option>
            </select>
          </div>

          <div>
            <label className="block text-xs text-gray-500 mb-1">Contact Segment</label>
            <select className="border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent">
              <option value="all">All Contacts</option>
              <option value="customers">Customers</option>
              <option value="prospects">Prospects</option>
              <option value="leads">Leads</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportFilters;